import { InventoryType, PREORDER_INVENTORY } from '@src/quince-site-common/src/domains/ProductPurchaseInfo'

export interface InventoryDataType {
  inventoryType: InventoryType
}

function getPreorder(spVariantMetaFieldOrIsPreOrder?: InventoryDataType | boolean) {
  let isPreorder = false

  if (typeof spVariantMetaFieldOrIsPreOrder === 'boolean') {
    isPreorder = spVariantMetaFieldOrIsPreOrder
  } else {
    isPreorder = spVariantMetaFieldOrIsPreOrder?.inventoryType === PREORDER_INVENTORY
  }

  return { showPreorder: isPreorder }
}

export default getPreorder
